import React, { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { useSelector } from 'react-redux';

import Sidebar from 'react-sidebar';

import MobileInfoBlock from './MobileInfoBlock';
import QuestionBlock from '../../common/QuestionBlock';

import ConnectForm from '../../common/forms/ConnectForm';
import CoursesCarouselMobile from './CoursesCarouselMobile';

import SidebarContent from '../../common/sidebar/SidebarContent';

import MobileHeader from '../common/header/MobileHeader';

import { getMobileSidebarStyles } from '../../../utils/sidebar-utils';

import { getInfoEmailAddress } from '../../../utils/domain-utils';

import FooterMobile from '../common/footer/FooterMobile';

// import CookiePolicyMobile from '../../common/cookie-policy/CookiePolicyMobile';

const Landing = () => {
  const { isAuthenticated } = useSelector(state => state);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleSidebarOpen = e => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  const closeSidebar = () => {
    setIsMenuOpen(false);
  };

  const emailAddress = getInfoEmailAddress();

  return (
    <>
      <Sidebar
        open={isMenuOpen}
        onSetOpen={setIsMenuOpen}
        sidebar={<SidebarContent closeSidebar={closeSidebar} />}
        styles={getMobileSidebarStyles()}
      >
        <div>
          <div className="m-start-screen-container" id="start-screen-container-id">
            <MobileHeader isAuthenticated={isAuthenticated} toggleSidebarOpen={toggleSidebarOpen} isTransparent />
            <div className="m-start-screen-body">
              <p className="m-start-screen-title">Educational platform for IT companies and individual developers</p>
              <p className="m-start-screen-text my-15px">
                We provide practical programming courses. Improve your programming skills and be successful!
              </p>
              <HashLink
                to="/#request-screen-container-id"
                className="m-start-screen-button mb-20px is-inline-block"
                smooth
              >
                Send request
              </HashLink>
              {/* <button className="m-start-screen-button mb-20px">Send request</button> */}
              <img src="img/mobile/start-screen-pic-mobile.jpg" className="is-fullwidth" />
            </div>
          </div>

          <div className="m-info-container" id="info-screen-container-id">
            <p className="m-container-header">
              Tutorium is a comprehensive educational platform that helps you improve your skills and productivity
            </p>
            <MobileInfoBlock
              iconPath="img/icons/landing-about-tab-1.svg"
              title="In-depth knowledge"
              text="All courses and programs are created by professional developers with a great experience. You will receive a
          professional mentor who will guide and help you during all education process. The mentor also will analyze
          your tasks and supervise you thoughout the course."
            />
            <MobileInfoBlock
              iconPath="img/icons/landing-about-tab-2.svg"
              title="Fundamental concepts"
              text="We pay a lot of attention to fundamental knowledge. As our practice shows, many developers do not know the
          basics very well. We help them to fill their gaps. A better understanding of the basis helps to improve their
          professional skills and become a better employee."
            />
            <MobileInfoBlock
              iconPath="img/icons/landing-about-tab-3.svg"
              title="Uniq personal programs"
              text="We have a lot of separate small courses divided info a lot of categories. We call them building blocks of our
          educational programs. They give us flexibility in creating programs. It allows us to create unique programs
          for each developer combining courses."
            />
            <img src="img/mobile/info-pic-mobile.png" className="is-fullwidth mt-25px" />
          </div>

          <div className="m-courses-container" id="courses-screen-container-id">
            <p className="m-container-header">Most popular courses</p>
            <CoursesCarouselMobile />
          </div>

          <div className="m-faq-container" id="faq-screen-container-id">
            <p className="m-container-header">FAQ</p>
            <p className="m-container-text has-text-centered my-15px">
              Have questions?
              <br />
              Send it to our email: <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
            </p>
            <QuestionBlock
              isMobile={true}
              question="How is the training process going?"
              answer="You send a request and our manager will contact you to get more details about the training. 
          We can test your knowledge for better understanding of your level. 
          Then we create a personal training program for you depending on your needs."
            />
            <QuestionBlock
              isMobile={true}
              question="Is it suitable for junior developers?"
              answer="We create a personal program for each student. 
          Our knowledge base is very big and we can create training programs for each level of student - from junior to high-qualified professional. 
          All our courses are created by professional developers and include all modern trends it IT."
            />
            <QuestionBlock
              isMobile={true}
              question="What about the pricing?"
              answer="The price is individual for each person or company and depends on needs. 
        It depends on your goals, level, amount of courses and time that you want to spend on training."
            />
            <QuestionBlock
              isMobile={true}
              question="Do you have any discounts?"
              answer="Yes, we have. For individual students, it depends on the program. 
          To more courses you want to learn, to cheaper each will be. 
          For companies, this rule is also valid, but in addition, we can do a discount for the number of students."
            />
          </div>

          <div className="m-request-container" id="request-screen-container-id">
            <p className="m-container-header">Do you want to try?</p>
            <p className="m-container-text my-15px">
              Fill the form and send the request. Our manager will contact you, answer all your questions. Then we will
              suggest a convenient time for the personal online meeting to discuss your requirements for training
            </p>
            <ConnectForm isMobile={true} />
          </div>
          <FooterMobile isGray />
        </div>
      </Sidebar>
      {/* <CookiePolicyMobile /> */}
    </>
  );
};

export default Landing;
